import React from 'react';
import { Route } from 'react-router-dom';
import TestCenter from './../containers/test-center/center';

export default [<Route path="/test-center" component={TestCenter} />];
